// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"7a55cf0c","422":"6849c6c7"}[chunkId] + ".chunk.js";
};